import { Component, OnInit } from '@angular/core';
import { SecurityService } from '../../services/security.service';
import { Router } from '@angular/router';
import { RestApiService } from 'src/app/services/rest-api.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit {

  userFirstName: any;
  idSymfony: any;
  Folders: any = [];
  
  constructor(public userService: UserService, 
              public route: Router, 
              public restApi: RestApiService
              ) 
  {

    if (this.userService.isAuthenticated()) {
      this.userFirstName = this.userService.currentUser.fname;
      this.idSymfony = this.userService.currentUser.keycloakUser.id;
    }

  }

  async ngOnInit(): Promise<void> {
    if(!this.userService.isAuthenticated()) {
      this.route.navigate(['/'] );
    }    
  }

}
